module.exports = __webpack_public_path__ + "static/media/download_sidebar.00e0dfbb.svg";